import { useMutation, useQuery } from '@tanstack/react-query';
import { confirmSejamOtp, getUserSejamInformation, sendSejamOtp, TSejamInfo } from '../api';
import { ErrorResponse } from '@shared/api';
import { ToastService } from '@shared/ui';

export const useUserSejamInformation = () =>
  useQuery<TSejamInfo, ErrorResponse>({
    queryKey: ['Sejam-info'],
    queryFn: () => getUserSejamInformation(),
  });

export const useSendSejamOtp = (onSuccess: () => void) =>
  useMutation<IOtpResponse, ErrorResponse>({
    mutationFn: sendSejamOtp,
    onError: (error) => {
      ToastService.error(error.formatMessage());
    },
    onSuccess: (data) => {
      onSuccess();
    },
  });

export const useConfirmSejamOtp = (onSuccess: () => void) =>
  useMutation<void, ErrorResponse, ConfirmSejamOtpRequest>({
    mutationFn: (input) => confirmSejamOtp({ otp: input.otp, token: input.token }),
    onSuccess: () => {
      onSuccess();
    },
  });

type ConfirmSejamOtpRequest = {
  otp: string;
  token: string;
};

export interface IOtpResponse {
  maskedPhoneNumber?: string;
  token?: string;
  expirationDate: string;
  expirationInMinutes: number;
}
